import { AddWidgetSelectedItem } from 'appToolbar/AddWidgetModal/AddWidgetModal';
import { WidgetType } from 'widgets/WidgetType';
import { useCallback, useReducer } from 'react';

enum AddWidgetSelectedItemsActionType {
    Add = 'Add',
    Remove = 'Remove',
    Reset = 'Reset',
}

type AddSelectedItem = {
    type: AddWidgetSelectedItemsActionType.Add;
    payload: AddWidgetSelectedItem;
};

export const addSelectedItem: (
    item: AddWidgetSelectedItem
) => AddSelectedItem = (item) => ({
    type: AddWidgetSelectedItemsActionType.Add,
    payload: item,
});

type RemoveSelectedItem = {
    type: AddWidgetSelectedItemsActionType.Remove;
    payload: AddWidgetSelectedItem;
};

export const removeSelectedItem: (
    item: AddWidgetSelectedItem
) => RemoveSelectedItem = (item) => ({
    type: AddWidgetSelectedItemsActionType.Remove,
    payload: item,
});

type Reset = {
    type: AddWidgetSelectedItemsActionType.Reset;
    payload: AddWidgetSelectedItem | undefined;
};
export const resetSelectedItems: (item?: AddWidgetSelectedItem) => Reset = (
    item
) => ({
    type: AddWidgetSelectedItemsActionType.Reset,
    payload: item,
});

type AddWidgetSelectedItemsAction =
    | AddSelectedItem
    | RemoveSelectedItem
    | Reset;

function selectedAddWidgetItemsReducer(
    state: AddWidgetSelectedItem[],
    action: AddWidgetSelectedItemsAction
): AddWidgetSelectedItem[] {
    switch (action.type) {
        case AddWidgetSelectedItemsActionType.Reset:
            return action.payload ? [action.payload] : [];
        case AddWidgetSelectedItemsActionType.Add:
            return [
                ...excludeWidgetType(state, action.payload.widget.type),
                action.payload,
            ];
        case AddWidgetSelectedItemsActionType.Remove:
            return excludeWidgetType(state, action.payload.widget.type);
        default:
            return state;
    }

    function excludeWidgetType(state: AddWidgetSelectedItem[], wt: WidgetType) {
        return state.filter((s) => s.widget.type !== wt);
    }
}

export function useSelectedAddWidgetItems() {
    const [selectedItems, dispatchSelectedItems] = useReducer(
        selectedAddWidgetItemsReducer,
        []
    );
    const dispatchAddSelectedItem = useCallback(
        (item: AddWidgetSelectedItem) =>
            dispatchSelectedItems(addSelectedItem(item)),
        [dispatchSelectedItems]
    );
    const dispatchRemoveSelectedItem = useCallback(
        (item: AddWidgetSelectedItem) =>
            dispatchSelectedItems(removeSelectedItem(item)),
        [dispatchSelectedItems]
    );
    const dispatchResetSelectedItems = useCallback(
        (item?: AddWidgetSelectedItem) =>
            dispatchSelectedItems(resetSelectedItems(item)),
        [dispatchSelectedItems]
    );
    return {
        selectedItems,
        addSelectedItem: dispatchAddSelectedItem,
        removeSelectedItem: dispatchRemoveSelectedItem,
        resetSelectedItems: dispatchResetSelectedItems,
    };
}
